/**
 * Acesso seguro ao armazenamento do navegador.
 *
 * O localStorage não existe sempre: navegação privada, bloqueio de dados de
 * terceiros e cota estourada fazem o acesso lançar exceção. Como preferência
 * de interface não vale derrubar o app, aqui tudo falha em silêncio e devolve
 * o padrão que você passou.
 */
function disponivel(area) {
  try {
    const s = globalThis[area];
    if (!s) return null;
    const t = '__teste__';
    s.setItem(t, '1');
    s.removeItem(t);
    return s;
  } catch {
    return null;
  }
}

const local  = disponivel('localStorage');
const sessao = disponivel('sessionStorage');

function criar(store) {
  return {
    ler(chave, padrao = null) {
      try {
        const v = store?.getItem(chave);
        return v === null || v === undefined ? padrao : v;
      } catch { return padrao; }
    },
    lerJSON(chave, padrao = {}) {
      try {
        const v = store?.getItem(chave);
        return v ? JSON.parse(v) : padrao;
      } catch { return padrao; }
    },
    gravar(chave, valor) {
      if (!store) return false;
      try { store.setItem(chave, valor); return true; } catch { return false; }
    },
    gravarJSON(chave, valor) {
      if (!store) return false;
      try { store.setItem(chave, JSON.stringify(valor)); return true; } catch { return false; }
    },
    remover(chave) {
      if (!store) return false;
      try { store.removeItem(chave); return true; } catch { return false; }
    },
    get ativo() { return !!store; },
  };
}

export const guardado  = criar(local);
export const daSessao  = criar(sessao);
